// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/poker-cards.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/poker-cards'

import { Icon, type IconComponentProps } from '../icon'

export const PokerCardsIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
